/**
 * @generated SignedSource<<57cdb5f15156a62e3f8f996d5734c7b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpBidModal_nftItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModalContent_nftItem">;
  readonly " $fragmentType": "NftPdpBidModal_nftItem";
};
export type NftPdpBidModal_nftItem$key = {
  readonly " $data"?: NftPdpBidModal_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModal_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpBidModal_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpBidModalContent_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "f2d267ef5025a5e09c8a4ddac45bc80c";

export default node;
